import React from 'react'
import { FieldProps, UiSchema } from '@rjsf/core'
import { QuantityDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { NewQuantity } from '../LatestCustomInput/NewQuantity'
import { useTranslation } from 'react-i18next'
import { dashify } from 'utils/dashify'

type QuantityFieldUISchema =
  | UiSchema
  | {
      'ui-label'?: string
      'selectable-units': string[]
      'min-value'?: number
      'max-value'?: number
      required?: boolean
      onValidationError: (property, error) => void
    }

export const RJSFQuantityField = (
  props: FieldProps<QuantityDto> & { uiSchema: QuantityFieldUISchema }
) => {
  const { t } = useTranslation()

  const quantityDto =
    Object.keys(props.formData || {}).length > 0
      ? props.formData
      : {
          selectableAbbreviations:
            (props.uiSchema && props.uiSchema['selectable-units']) || [],
          value: 0,
          unit:
            props.uiSchema && props.uiSchema['selectable-units']
              ? props.uiSchema['selectable-units'][0]
              : '',
        }

  const handleChange = (newQuantity: QuantityDto) => {
    props.onChange(newQuantity)
  }

  return (
    <>
      <NewQuantity
        quantity={quantityDto}
        onValidation={(valid) =>
          props.formContext.onValidationError &&
          setTimeout(() =>
            props.formContext.onValidationError({ [props.idSchema.$id]: valid })
          )
        }
        selectableAbbreviations={quantityDto.selectableAbbreviations}
        onChangeQuantity={handleChange}
        label={t(
          `project:ws-form-${dashify(props.uiSchema['ui:label'])}`,
          props.uiSchema['ui:label']
        )}
        minValue={props.uiSchema['min-value']}
        maxValue={props.uiSchema['max-value']}
        required={props.uiSchema.required}
        disableUnit={!quantityDto.selectableAbbreviations?.length}
      />
    </>
  )
}
